import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import ApiConfigModal from "./Components/ApiConfigModal";
import ReserveringssystemenTable from "./Components/ReserveringssystemenTable";
import ImportSection from "./Components/ImportSection";
import TommyArtikelenModal from "./Components/TommyArtikelenModal";
import SneaTabs from "../../../Components/SneaTabs";
import {
  fetchReserveringssystemen,
  createReserveringssysteem,
  updateReserveringssysteem,
  deleteReserveringssysteem,
  toggleActiveReserveringssysteem
} from "./Reducers/actions";
import {
  fetchToegangscontroles,
  toggleToegangscontrole,
  testToegangscontrole,
  refreshToken
} from "../Toegangscontrole/Reducers/actions";
import ToegangscontroleForm from "../Toegangscontrole/Components/ToegangscontroleForm";
import DoorsyRealestates from "../Toegangscontrole/Components/DoorsyRealestates";
import moment from "moment";
import { message as showMessage } from "../../../Reducers/loading/actions";

const ReserveringssystemenPage = ({
  reserveringssystemen,
  loading,
  error,
  fetchReserveringssystemen,
  createReserveringssysteem,
  updateReserveringssysteem,
  deleteReserveringssysteem,
  toggleActiveReserveringssysteem,
  // Toegangscontrole props
  toegangscontroles,
  toegangscontroleError,
  testResult,
  fetchToegangscontroles,
  toggleToegangscontrole,
  testToegangscontrole,
  refreshToken
}) => {
  const dispatch = useDispatch();
  const message = (time, type, msg) => dispatch(showMessage(time, type, msg));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [importing, setImporting] = useState(false);
  const [showingTommyArtikelen, setShowingTommyArtikelen] = useState(false);
  const [tommyArtikelen, setTommyArtikelen] = useState([]);

  // Toegangscontrole state
  const [toegangscontroleLoading, setToegangscontroleLoading] = useState(true);
  const [showToegangscontroleForm, setShowToegangscontroleForm] = useState({ show: false, provider: null });

  useEffect(() => {
    fetchReserveringssystemen();
    loadToegangscontroles();
  }, [fetchReserveringssystemen]);

  const loadToegangscontroles = async () => {
    setToegangscontroleLoading(true);
    await fetchToegangscontroles();
    setToegangscontroleLoading(false);
  };

  // Check of er categorieën beschikbaar zijn
  const checkCategoriesAvailable = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/admin/standplaatsen/categorien", {
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();
      // We don't need to store this in state anymore, just for the callback
      return data.results && data.results.length > 0;
    } catch (error) {
      console.error("Fout bij ophalen categorieën:", error);
      return false;
    }
  };

  const handleOpenModal = (item = null) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditingItem(null);
    setIsModalOpen(false);
  };

  const handleSubmitConfig = async (values) => {
    try {
      // Maak een schone kopie van de form values zonder circulaire referenties
      const cleanData = {
        naam: values.naam || '',
        url: values.url || '',
        authMethod: values.authMethod || 'none',
        authConfig: values.authConfig ? {
          token: values.authConfig.token || '',
          username: values.authConfig.username || '',
          password: values.authConfig.password || '',
          keyName: values.authConfig.keyName || '',
          keyValue: values.authConfig.keyValue || ''
        } : {},
        headers: values.headers ? values.headers.map(h => ({
          name: h.name || '',
          value: h.value || ''
        })) : []
      };
      
      let result;
      if (editingItem && editingItem._id) {
        // Update bestaand reserveringssysteem
        result = await updateReserveringssysteem(editingItem._id, cleanData);
      } else {
        // Maak nieuw reserveringssysteem aan
        result = await createReserveringssysteem(cleanData);
      }
      
      if (result.type === "success") {
        setIsModalOpen(false);
        message(3000, "success", editingItem ? "Reserveringssysteem succesvol bijgewerkt!" : "Reserveringssysteem succesvol opgeslagen!");
        // Refresh de lijst
        fetchReserveringssystemen();
      } else {
        message(4000, "warning", "Fout bij opslaan: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    }
  };

  const handleDelete = async (id, naam) => {
    if (window.confirm(`Weet je zeker dat je "${naam}" wilt verwijderen?`)) {
      try {
        const result = await deleteReserveringssysteem(id);
        if (result.type === "success") {
          message(3000, "success", "Reserveringssysteem succesvol verwijderd!");
        } else {
          message(4000, "warning", "Fout bij verwijderen: " + result.payload);
        }
      } catch (error) {
        message(4000, "warning", "Er is een fout opgetreden: " + error.message);
      }
    }
  };

  const handleToggleActive = async (id) => {
    try {
      const result = await toggleActiveReserveringssysteem(id);
      if (result.type !== "success") {
        message(4000, "warning", "Fout bij wijzigen status: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    }
  };

  // Handler voor Tommy artikelen
  const handleTommyArtikelenFetched = (artikelen) => {
    setTommyArtikelen(artikelen);
    setShowingTommyArtikelen(true);
  };

  // Toegangscontrole handlers
  const getDoorsyConfig = () => {
    return toegangscontroles?.find(t => t.naam === 'doorsy');
  };

  const doorsyConfig = getDoorsyConfig();

  const handleToegangscontroleToggle = async (id) => {
    await toggleToegangscontrole(id);
    await loadToegangscontroles();
  };

  const handleToegangscontroleTest = async (id) => {
    await testToegangscontrole(id);
  };

  const handleTestWebhook = async (id) => {
    try {
      const response = await fetch(`/api/admin/toegangscontrole/${id}/test-webhook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
      });
      const data = await response.json();
      if (data.success) {
        message(3000, "success", `Webhook test succesvol! ${data.message}`);
      } else {
        message(4000, "warning", `Webhook test gefaald: ${data.message}`);
      }
    } catch (error) {
      console.error('Webhook test error:', error);
      message(4000, "warning", 'Er is een fout opgetreden bij het testen van de webhook');
    }
  };

  const handleRefreshToken = async (id) => {
    const result = await refreshToken(id);
    if (result.success) {
      message(3000, "success", 'Access token succesvol vernieuwd!');
      await loadToegangscontroles();
    } else {
      message(4000, "warning", `Fout bij vernieuwen token: ${result.message || result.error}`);
    }
  };

  const handleGetAuthCode = () => {
    const config = doorsyConfig?.configuratie;
    if (!config) {
      message(4000, "warning", 'Configureer eerst Doorsy voordat je een authcode kunt ophalen');
      return;
    }
    if (!config.client_id || !config.api_base_url) {
      message(4000, "warning", 'Client ID en API Base URL zijn vereist voor authcode ophalen');
      return;
    }
    const baseUrl = config.api_base_url.replace(/\/$/, '');
    const clientId = encodeURIComponent(config.client_id);
    const authUrl = `${baseUrl}/oauth/authorize/?response_type=code&client_id=${clientId}`;
    message(5000, "info", 'Ga naar de Doorsy autorisatie pagina. Na autorisatie kopieer je de code uit de URL en plak deze in het configuratie formulier.');
    window.open(authUrl, '_blank', 'width=600,height=600');
  };

  const handleConfigureToegangscontrole = (provider = 'doorsy') => {
    setShowToegangscontroleForm({ show: true, provider });
  };

  const handleToegangscontroleFormClose = () => {
    setShowToegangscontroleForm({ show: false, provider: null });
    loadToegangscontroles();
  };

  const getStatusBadge = (config) => {
    if (!config) return <span className="badge bg-secondary">Niet geconfigureerd</span>;
    switch (config.status) {
      case 'niet_geconfigureerd':
        return <span className="badge bg-secondary">Niet geconfigureerd</span>;
      case 'geconfigureerd':
        return <span className="badge bg-warning">Geconfigureerd</span>;
      case 'geautoriseerd':
        return <span className="badge bg-success">Geautoriseerd</span>;
      case 'fout':
        return <span className="badge bg-danger">Fout</span>;
      default:
        return <span className="badge bg-secondary">Onbekend</span>;
    }
  };

  // Tab content: API Koppelingen
  const renderApiKoppelingenContent = () => (
    <div className="p-3">
      {loading && (
        <div className="text-center py-3">
          <i className="fas fa-spinner fa-spin"></i> Laden...
        </div>
      )}

      {error && (
        <div className="alert alert-danger">
          <i className="fas fa-exclamation-triangle"></i> {error}
        </div>
      )}

      {!loading && reserveringssystemen.length === 0 ? (
        <div className="text-center py-4">
          <i className="fas fa-plug fa-3x text-muted mb-3"></i>
          <h5 className="text-muted">Geen API koppelingen geconfigureerd</h5>
          <p className="text-muted">
            Voeg een API koppeling toe om te beginnen met reserveringssystemen integratie.
          </p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleOpenModal()}
          >
            <i className="fa fa-plus me-2"></i>
            Eerste API Koppeling Toevoegen
          </button>
        </div>
      ) : !loading && reserveringssystemen.length > 0 && (
        <ReserveringssystemenTable
          reserveringssystemen={reserveringssystemen}
          onEdit={handleOpenModal}
          onDelete={handleDelete}
          onToggleActive={handleToggleActive}
        />
      )}

      {!loading && reserveringssystemen.length > 0 && (
        <ImportSection
          reserveringssystemen={reserveringssystemen}
          selectedSystem={selectedSystem}
          setSelectedSystem={setSelectedSystem}
          importing={importing}
          setImporting={setImporting}
          onTommyArtikelenFetched={handleTommyArtikelenFetched}
          checkCategoriesAvailable={checkCategoriesAvailable}
        />
      )}
    </div>
  );

  // Tab content: Doorsy Configuratie
  const renderDoorsyConfigContent = () => (
    <div className="p-3">
      {toegangscontroleLoading ? (
        <div className="text-center py-3">
          <i className="fas fa-spinner fa-spin"></i> Laden...
        </div>
      ) : (
        <div className="row">
          <div className="col-md-12">
            <div className="card border-0">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="fas fa-door-closed me-2 text-info"></i>
                  Doorsy API Configuratie
                </h5>
                <p className="text-muted mb-3">
                  Integratie met Doorsy voor toegangscontrole en reserveringsbeheer.
                </p>

                <div className="mb-3">
                  {getStatusBadge(doorsyConfig)}
                  {doorsyConfig?.actief && (
                    <span className="badge bg-success ms-2">Actief</span>
                  )}
                </div>

                {doorsyConfig && (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <small className="text-muted d-block">Laatste update:</small>
                        <strong>{moment(doorsyConfig.bijgewerkt).fromNow()}</strong>
                      </div>
                      <div className="col-md-6">
                        <small className="text-muted d-block">Authentication:</small>
                        <strong className="text-info">
                          {doorsyConfig.configuratie?.auth_type?.replace('_', ' ').toUpperCase() || 'API Key'}
                        </strong>
                      </div>
                    </div>

                    {doorsyConfig.fout_bericht && (
                      <div className="alert alert-danger">
                        <i className="fas fa-exclamation-circle me-2"></i>
                        {doorsyConfig.fout_bericht}
                      </div>
                    )}
                  </>
                )}

                <div className="btn-group w-100 flex-wrap" role="group">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleConfigureToegangscontrole('doorsy')}
                  >
                    <i className="fas fa-cog me-1"></i>
                    Configureren
                  </button>

                  {doorsyConfig && (
                    <>
                      <button
                        className={`btn ${doorsyConfig.actief ? 'btn-warning' : 'btn-success'}`}
                        onClick={() => handleToegangscontroleToggle(doorsyConfig._id)}
                      >
                        <i className={`fas ${doorsyConfig.actief ? 'fa-pause' : 'fa-play'} me-1`}></i>
                        {doorsyConfig.actief ? 'Uitschakelen' : 'Inschakelen'}
                      </button>

                      {doorsyConfig.configuratie?.auth_type === 'oauth2' && doorsyConfig.configuratie?.client_id && (
                        <>
                          <button
                            className="btn btn-secondary"
                            onClick={handleGetAuthCode}
                            title="Open Doorsy OAuth authorisatie in nieuw venster"
                          >
                            <i className="fas fa-external-link-alt me-1"></i>
                            OAuth Authcode
                          </button>

                          <button
                            className="btn btn-warning"
                            onClick={() => handleRefreshToken(doorsyConfig._id)}
                            title="Gebruik refresh token om nieuwe access token op te halen"
                            disabled={!doorsyConfig.oauth_tokens?.refresh_token}
                          >
                            <i className="fas fa-sync-alt me-1"></i>
                            Refresh Token
                          </button>
                        </>
                      )}

                      <button
                        className="btn btn-info"
                        onClick={() => handleToegangscontroleTest(doorsyConfig._id)}
                      >
                        <i className="fas fa-vial me-1"></i>
                        Testen
                      </button>

                      {doorsyConfig.configuratie?.webhook_config?.url && (
                        <button
                          className="btn btn-success"
                          onClick={() => handleTestWebhook(doorsyConfig._id)}
                        >
                          <i className="fas fa-webhook me-1"></i>
                          Test Webhook
                        </button>
                      )}
                    </>
                  )}
                </div>

                {testResult && (
                  <div className={`alert ${testResult.success ? 'alert-success' : 'alert-danger'} mt-3`}>
                    <i className={`fas ${testResult.success ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                    <strong>Test resultaat:</strong> {testResult.message}
                    {testResult.user_info && (
                      <div className="mt-2">
                        <small>Gebruiker: {testResult.user_info.name || testResult.user_info.email}</small>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // Tabs configuratie
  const tabs = [
    {
      id: 'api-koppelingen',
      label: 'API Koppelingen',
      icon: 'fas fa-plug',
      content: renderApiKoppelingenContent()
    },
    {
      id: 'doorsy-config',
      label: 'Doorsy Configuratie',
      icon: 'fas fa-door-closed',
      content: renderDoorsyConfigContent()
    },
    {
      id: 'realestates',
      label: 'Realestates',
      icon: 'fas fa-building',
      content: <DoorsyRealestates />
    }
  ];

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Reserveringssystemen</h3>
        <div className="box-tools pull-right">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleOpenModal}
          >
            <i className="fa fa-plus"></i>&nbsp; API Koppeling Toevoegen
          </button>
        </div>
      </div>
      <div className="box-body p-0">
        <SneaTabs
          tabs={tabs}
          variant="default"
        />
      </div>

      <ApiConfigModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitConfig}
        initialValues={editingItem}
      />

      <TommyArtikelenModal
        isOpen={showingTommyArtikelen}
        onClose={() => setShowingTommyArtikelen(false)}
        artikelen={tommyArtikelen}
      />

      {/* Toegangscontrole Configuration Modal */}
      {showToegangscontroleForm.show && (
        <ToegangscontroleForm
          onClose={handleToegangscontroleFormClose}
          provider={showToegangscontroleForm.provider}
          existingConfig={doorsyConfig}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  reserveringssystemen: state.reserveringssystemen.items,
  loading: state.reserveringssystemen.loading,
  error: state.reserveringssystemen.error,
  // Toegangscontrole state
  toegangscontroles: state.toegangscontrole?.toegangscontroles || [],
  toegangscontroleError: state.toegangscontrole?.error,
  testResult: state.toegangscontrole?.testResult
});

const mapDispatchToProps = {
  fetchReserveringssystemen,
  createReserveringssysteem,
  updateReserveringssysteem,
  deleteReserveringssysteem,
  toggleActiveReserveringssysteem,
  // Toegangscontrole actions
  fetchToegangscontroles,
  toggleToegangscontrole,
  testToegangscontrole,
  refreshToken
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveringssystemenPage);